// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@flip/XDL/PreStyle/typography";
import { xBaseTheme } from "@flip/XDL/types";
import { color, xScreen } from "@flip/XDL/Utilities";
import { DataTableCssOverrides } from "@insite/mobius/DataTable/DataTable";
import DataTableCellBase from "@insite/mobius/DataTable/DataTableCellBase";
import DataTablePresentationPropsDefault from "@insite/mobius/DataTable/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DataTablePresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            cell: css`
                padding: 12px;
                min-height: 44px;
                height: auto;
                border-bottom: 0;
            `,
            head: css`
                background: ${color("common.ui9")};
            `,
            header: css`
                background: ${color("common.ui9")};
                padding: 8px 12px;
                height: 36px;
                border-bottom: 0;
                line-height: 1;
                
                ${IconWrapper} {
                    color: ${color("common.ui1")};
                }
            `,
            row: css`
                background: ${color("common.ui1")};
                line-height: 1;

                &:hover {
                    background-color: ${color("common.ui2")};
                }
            `,
            evenRow: css`
                background: ${color("common.ui2")};
            `,
        } as DataTableCssOverrides,
        headerTypographyProps: {
            mergeCss: true,
            size: 12,
            weight: fontConfig.weight.regular,
            color: "common.ui1",
            css: css`
                letter-spacing: 0;
                line-height: 20px;
            `,
        },
        cellTypographyProps: {
            mergeCss: true,
            color: "text",
            size: 14,
            css: css`
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
    },
} as xBaseTheme["dataTable"];
